import { createContext, useContext } from "react";
import { FeaturePermission } from "@/__generated__/featurePermissions";
import { AuthUser } from "@/auth/helpers";
import { UserMedspa } from "@/auth/useAuthState";
import { UserQuery } from "@/graphql/queries/user.graphql.types";

export const UserAuthContext = createContext<UseUserResult | null>(null);

export type UseUserResult = {
  user?: AuthUser | undefined;
  loading: boolean;
  medspa?: string;
  onMedspaChange?: (medspa: string) => void;
  additionalUserDetails?: UserQuery;
  providerUserMedspa?: UserMedspa;
  userMedspa?: UserMedspa;
  hasFeaturePermission?: (
    permission: FeaturePermission,
    oldRoles?: string[]
  ) => boolean;
  hasAnyOfFeaturePermissions?: (
    permissions: FeaturePermission[],
    oldRoles?: string[]
  ) => boolean;
  hasUrlPermission?: (url: string) => boolean;
  newPermissionsEnabledForUser?: boolean;
  newRoleId?: string;
};

const useUser = (): UseUserResult => {
  const context = useContext(UserAuthContext);
  if (!context) {
    throw new Error("Must have proper ContextProvider defined in parent tree.");
  }
  return context;
};

export { useUser };
